import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../tracker";

/** Records one page view per route change (admin routes excluded). */
export default function PageTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const timer = setTimeout(() => trackEvent("page", pathname), 400);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}
